/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Overage_Limit_Per_MonthInputs */



/**
* | output |
* | --- |
* | "Overage limit" |
*
* @param {Usage_Overage_Limit_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_overage_limit_per_month = /** @type {((inputs?: Usage_Overage_Limit_Per_MonthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Overage_Limit_Per_MonthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überschuss-Limit")
	return /** @type {LocalizedString} */ ("Overage limit")
});